
export const navItems = [
  { label: 'Homepage', href: '/', hasMegaMenu: true },
  { label: 'Products', href: '/products', hasMegaMenu: true },
  { label: 'Portfolio', href: '/portfolio' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact Us', href: '/contact' },
  { label: 'Onboarding', href: '/onboarding' },
  { 
    label: 'Admin Portal', 
    href: '/admin', 
    hasMegaMenu: true,
    adminOnly: true,
    megaMenuItems: [
      { label: 'Dashboard', href: '/admin', description: 'Executive overview and metrics' },
      { label: 'Users & Companies', href: '/admin?tab=users', description: 'Manage users and organisations' },
      { label: 'CRM & Marketing', href: '/admin?tab=crm', description: 'Customer relationship management' },
      { label: 'Analytics & Reports', href: '/admin?tab=analytics', description: 'Performance insights and data' },
      { label: 'Security & Settings', href: '/admin?tab=security', description: 'System security and configuration' },
      { label: 'Onboarding Management', href: '/admin/onboarding/templates', description: 'Manage employee onboarding' }
    ]
  },
  { label: 'Project Wizard', href: '/website-wizard', variant: 'primary' as const }
];

export const actionButtons = [];
